import * as React from "react";
import styles from "./styles.scss";

const Body = (props: React.PropsWithChildren<unknown>) => {
  return <div className={styles.root}>{props.children}</div>;
};

export default Body;
